/* global $ */
import React, { createContext, useEffect, useState, useCallback } from "react";
import Loader from "../Components/Loader";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
dayjs.extend(customParseFormat);
const initialState = {
  loading: false,
  userID: null,
};

export const AuthContextProvider = createContext(initialState);
export const LoaderContext = createContext(initialState);

const AuthContext = ({ children }) => {

  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("userID")
  );

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("userData")) || null
  );
  return (
    <AuthContextProvider.Provider
      value={{

        isAuthenticated,
        setIsAuthenticated,
        user,
        setUser,
      }}
    >
      {children}

    </AuthContextProvider.Provider>
  );
};
const LoaderProvider = ({ children }) => {
  const [selectedLanguageID, setSelectedLanguageID] = useState((localStorage.getItem("selectedLangID")) || 1)
  const [fetchedLocation, setLocation] = useState(() => {
    const stored = localStorage.getItem("userLocation");
    return stored ? JSON.parse(stored) : { lat: null, lon: null };
  });
  const [loader, setLoader] = useState(false);
  const [activeCategory, setActiveCategory] = useState('All');
  const [isCartUpdate, setIsCartUpdate] = useState(false)
  const [isLocationUpdate, setIsLocationUpdate] = useState(false);
  const [isLanguageUpdate, setIsLanguageUpdate] = useState(false);
  const [pujaStatus, setPujaStatus] = useState(null);
  const timezoneOffset = -new Date().getTimezoneOffset() / 60;

  const convertTo12Hour = (timeString) => {
    // Parse with fallback to "HH:mm:ss" format
    const parsed = dayjs(timeString, "H:m:s"); // handles 1-digit hours/mins too
    return parsed.isValid() ? parsed.format("hh:mm A") : "Invalid time";
  };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }

  useEffect(() => {
    if (fetchedLocation.lat === null || fetchedLocation.lon === null) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const coords = {
              lat: position.coords.latitude,
              lon: position.coords.longitude,
            };
            setLocation(coords);
            localStorage.setItem("userLocation", JSON.stringify(coords));
          },
          (error) => {
            console.error("Error getting location:", error);
            const fallback = { lat: 20.5937, lon: 78.9629 }; // Fallback (India)
            setLocation(fallback);
            localStorage.setItem("userLocation", JSON.stringify(fallback));
          }
        );
      } else {
        console.error("Geolocation not supported.");
      }
    }
  }, [fetchedLocation.lat, fetchedLocation.lon]);

  useEffect(() => {
    if (isLanguageUpdate) {
      setIsLanguageUpdate(false)
    }
  }, [isLanguageUpdate])
  return (
    <LoaderContext.Provider value={{
      loader, setLoader, isLanguageUpdate, setIsLanguageUpdate, selectedLanguageID, formatToIndianCurrency, setSelectedLanguageID, activeCategory, convertTo12Hour, pujaStatus, setPujaStatus, setActiveCategory, setIsLocationUpdate, isLocationUpdate, setIsCartUpdate, isCartUpdate, fetchedLocation, timezoneOffset
    }}>
      {children}
      {loader && <Loader />}
    </LoaderContext.Provider>
  );
};
export { LoaderProvider };
export default AuthContext;
